import finalSeminar from "./finalSeminar.js"
import confirmation from "./phdConfirmation.js"
import rwthVisit from "./rwthVisit.js"
import agrawalMiner from "./agrawalMiner.js"
import differences from "./differencesExoEndo.js"

const collection = [
    confirmation,
    differences,
    rwthVisit,
    agrawalMiner,
    finalSeminar
]

export default collection;